export enum DracoButtonSizeValues {
  XSmall = 'xsmall',
  Small = 'small',
  Medium = 'medium',
  Large = 'large'
};
export type DracoButtonSizes = `${DracoButtonSizeValues}`;

export enum DracoButtonColorValues {
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
  Amber = 'amber',
  Error = 'error'
};
export type DracoButtonColors = `${DracoButtonColorValues}`;

export enum DracoButtonIconPositionValues {
  Leading = 'leading',
  Trailing = 'trailing'
};
export type DracoButtonIconPositions = `${DracoButtonIconPositionValues}`;

export enum DracoButtonShapeValues {
  Square = 'square',
  Circle = 'pill',
  Rounded = 'rounded'
};
export type DracoButtonShapes = `${DracoButtonShapeValues}`;